import type { BannerCampaign } from '@/domains/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';

import type { StoreError } from '../../interfaces/error';

export interface MerchandizingBannersState {
  middle: MerchandizingBannerState;
  bottom: MerchandizingBannerState;
  listing: MerchandizingBannerState;
}

export interface MerchandizingBannerState {
  isFetching: boolean;
  campaigns?: BannerCampaign[];
  error?: StoreError;
}

export const merchandizingBannersInitialState: MerchandizingBannersState = {
  middle: {
    isFetching: false,
  },
  bottom: {
    isFetching: false,
  },
  listing: {
    isFetching: false,
  },
};
